import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MemberEditorMainComponent } from './member-editor-main/member-editor-main.component';
import { MemberEditorComponent } from './member-editor/member-editor.component';
import { CommonComponentModule } from '../common/common.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [MemberEditorMainComponent, MemberEditorComponent],
  exports:[MemberEditorMainComponent],
  imports: [
    CommonModule,
    CommonComponentModule,
    FormsModule,
    SharedModule
  ]
})
export class MembereditorModule { }

// translation loader moved to SharedModule
